module.exports = {
  title: 'Slide to Reveal with React Native Skia 🪄',
  author: 'Enzo Manuel Mangano',
  date: '2023-11-29',
  slug: 'slide-to-reveal',
  tags: ['skia', 'gesture-handler'],
};
